"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPage = NotFoundPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var auth_layout_1 = require("../components/auth/auth-layout");
var console_layout_1 = require("../components/layouts/console-layout");
var not_found_content_1 = require("../components/not-found/not-found-content");
var hooks_1 = require("../store/hooks");
function NotFoundPage() {
    var accessToken = (0, hooks_1.useAppSelector)(function (state) { return state.user.token; });
    if (accessToken) {
        return ((0, jsx_runtime_1.jsx)(console_layout_1.ConsoleLayout, { children: (0, jsx_runtime_1.jsx)("div", { className: "flex h-full items-center justify-center", children: (0, jsx_runtime_1.jsx)(not_found_content_1.NotFoundContent, { isLoggedIn: true }) }) }));
    }
    return ((0, jsx_runtime_1.jsx)(auth_layout_1.AuthLayout, { title: "Page not found", subtitle: "The page you're looking for doesn't exist or has been moved.", children: (0, jsx_runtime_1.jsx)(not_found_content_1.NotFoundContent, { isLoggedIn: false }) }));
}
